import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { Map, SearchInput, Filter, Markers } from '@tesla/react-google-map-fork';

// Actions
import { retrieveLocationDetails } from '../actions';
import { API_BASE_URL, STORES, SERVICE, SUPERCHARGERS, DESTINATION_CHARGERS } from '../constants';

const BMapContainers = props => {
  const { app, content } = props;
  const mapProps = {
    mapOptions: {
      center: { lat: 39.915, lng: 116.404 },
      minZoom: 5,
      zoom: 12,
      mapProvider: 'BAIDU',
      getLocationAPI: `${API_BASE_URL}${app.api.locationDetails}`,
    },
    baiduScriptOptions: {
      ak: 'bjg1yDf5Z8k0BwYbpNpHRILL',
      v: '3.0',
    },
    teslaMapPresetOptions: {
      zoomUserLocation: 11,
      zoomSearchLocation: 9,
      zoomSearchBound: 7,
      defaultTheme: true,
      detectUserLocation: true,
      useCustomMapStyle: true,
      styles: { height: 'calc(100vh - 52px)', borderRadius: '0.5em' },
      card: {
        footerPrimaryLink: 'https://www.tesla.cn/drive',
        footerSecondaryLink: 'https://www.tesla.cn/findus/list',
      },
      v: '2',
    },
  };

  const locCache = props.locations.locationsCache;
  const locFilters = props.locations.filters;
  let loc = [];
  locFilters.forEach(filter => {
    if (locCache && locCache.store) {
      loc = loc.concat(locCache[filter][0].locations);
    }
  });

  const filters = [
    {
      type: STORES,
      label: content.locationFilter.filters.store,
      icon: 'tsla-icon-badge-circle',
    },
    {
      type: SERVICE,
      label: content.locationFilter.filters.service,
      icon: 'tsla-icon-wrench-circle',
    },
    {
      type: SUPERCHARGERS,
      label: content.locationFilter.filters.supercharger,
      icon: 'tsla-icon-bolt-circle-red',
    },
    {
      type: DESTINATION_CHARGERS,
      label: content.locationFilter.filters.destinationCharger,
      icon: 'tsla-icon-bolt-circle-dark',
    },
  ];

  const markersProps = {
    zoomSelectedMarker: 9,
  };

  const filterStyles = { top: 'calc(5vh + 51px)' };

  return (
    <div>
      <Map {...mapProps} content={content}>
        <SearchInput
          inputID="locationSearchInput"
          inputName="mapSearchInput"
          placeholderText={content.search.placeholder}
        />
        <Markers locations={loc} globalSettings={markersProps} />
        <Filter
          content={content.locationFilter}
          filters={filters}
          styles={filterStyles}
          filterLabel={content.locationFilter.desktopLabel}
        />
      </Map>
    </div>
  );
};

BMapContainers.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  app: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  locations: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    app: state.app,
    content: state.content,
    locations: state.locations,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    retrieveLocationDetails: id => dispatch(retrieveLocationDetails(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BMapContainers);
